/**
 * Utilidades da Agenda da equipe usadas pela tela e pelo aviso global.
 * "Entrar na reunião" = abrir a conversa da reunião e ligar o vídeo nela (se a
 * chamada já estiver rolando, o servidor trata o "ligar" como "entrar").
 */
import { iniciar } from './chamadaEquipe';

export async function entrarNaReuniao(navigate, r, { video = true } = {}) {
  if (!r || !r.canal_id) return;
  navigate(`/escritorio/chat?c=${r.canal_id}`);
  try { await iniciar(r.canal_id, r.titulo, { video }); } catch (_) { /* a tela da chamada mostra o erro */ }
}

/** Já dá pra entrar: de 15 min antes até o fim. */
export function podeEntrar(r, agora = Date.now()) {
  if (!r || r.cancelada) return false;
  return agora >= new Date(r.inicio).getTime() - 15 * 60000 && agora <= new Date(r.fim).getTime();
}

export function emAndamento(r, agora = Date.now()) {
  return !!r && !r.cancelada && agora >= new Date(r.inicio).getTime() && agora <= new Date(r.fim).getTime();
}

export const hora = (iso) => new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
export const diaCurto = (iso) => new Date(iso).toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit' }).replace('.', '');
export const quando = (r) => `${diaCurto(r.inicio)} · ${hora(r.inicio)}–${hora(r.fim)}`;

export function faltam(iso, agora = Date.now()) {
  const min = Math.round((new Date(iso).getTime() - agora) / 60000);
  if (min <= 0) return 'agora';
  if (min < 60) return `em ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `em ${h}h${min % 60 ? String(min % 60).padStart(2, '0') : ''}`;
  const d = Math.round(h / 24);
  return `em ${d} dia${d > 1 ? 's' : ''}`;
}
